<template>
  <gs1-alert>
    <p>
      {{ $t('title', {
            company:
              saveGet(glnsVerifiedResponse, null, 'gs1Licence', 'licenseeName') ||
              saveGet(gtinsVerifiedResponse, '',  'gs1Licence', 'licenseeName'),
            epc: gs1Id || '' }) }}
    </p>
    <p style='font-size: 16px; margin-top: 5px'>
      {{ $t('message') }}
    </p>
    <p style='font-size: 16px; margin-top: 5px'>
      {{ $t('please') }}
      <a href='https://www.gs1-germany.de/service/kontakt/' target='_blank' rel='noopener'>
        {{ $t('contact_gs1') }}
      </a>
      {{ $t('further_support') }}
    </p>
  </gs1-alert>
</template>

<script>
import Gs1Alert from './Gs1Alert'
import { saveGet } from '../../mixins/saveGet'

export default {
  name: 'Gs1AlertNonNumeric',
  props: ['gs1Id', 'glnsVerifiedResponse', 'gtinsVerifiedResponse'],
  mixins: [saveGet],
  components: {
    Gs1Alert
  },
  i18n: {
    messages: {
      de: {
        title: 'Die EAN/GTIN bzw. GLN {epc} ist unter der Firma {company} registriert',
        message: 'Dieser Eintrag ist inaktiv und wird nicht mehr vom ursprünglichen Hersteller oder Distributor auf dem neuesten Stand gehalten.',
        please: 'Bitte ',
        contact_gs1: 'kontaktieren Sie GS1',
        further_support: ' wenn Sie Hilfe benötigen.'
      },
      en: {
        title: 'The EAN/GTIN or GLN {epc} is registered under the company {company}',
        message: 'This entry is inactive and is no longer being kept up-to-date by the original manufacturer or distributor.',
        please: 'Please ',
        contact_gs1: 'contact GS1',
        further_support: ' for further support.'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/Gs1AlertCompanyInactive.vue